import React, { useState } from "react";
import { Button } from "../../modules";
import { ImportPopup } from "./ImportPopup";

type ImportButtonProps = {
  fileUrl: string
  onImport: (form: FormData ,cb: any) => void
};

const ImportButton: React.FC<ImportButtonProps> = ({ fileUrl, onImport }) => {
  const [activeModal, setActiveModal] = useState(false)
  const toggleModal = () => setActiveModal(prev => !prev)

  return (
    <>
      <Button label="Nhập excel" buttonType="success" onClick={toggleModal} />
      {activeModal ? <ImportPopup onClose={toggleModal} onImport={onImport} fileUrl={fileUrl} toggleModal={toggleModal}/> : <></>}
    </>
  );
};

export default ImportButton;
